import React from 'react';

const Layout = ({ children }) => {
  return <div className="min-h-screen">{children}</div>;
};

export default Layout;